import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          <div className="flex-shrink-0 flex items-center py-2">
            <img
              src="https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/f2c19796cf6e2cf808b2267d17a34318.png"
              alt="Beaulieu Dental"
              className="h-20 w-auto object-contain"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-[#444c42] hover:text-[#D0A24F]' : 'text-white hover:text-[#F5d383]'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('options')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-[#444c42] hover:text-[#D0A24F]' : 'text-white hover:text-[#F5d383]'
              }`}
            >
              Implant Options
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-[#444c42] hover:text-[#D0A24F]' : 'text-white hover:text-[#F5d383]'
              }`}
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-[#444c42] hover:text-[#D0A24F]' : 'text-white hover:text-[#F5d383]'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('booking')}
              className="bg-[#D0A24F] text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-[#F5d383] transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Appointment
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer"
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span
                className={`block h-0.5 w-full transition-all ${
                  isScrolled ? 'bg-[#444c42]' : 'bg-white'
                }`}
              ></span>
              <span
                className={`block h-0.5 w-full transition-all ${
                  isScrolled ? 'bg-[#444c42]' : 'bg-white'
                }`}
              ></span>
              <span
                className={`block h-0.5 w-full transition-all ${
                  isScrolled ? 'bg-[#444c42]' : 'bg-white'
                }`}
              ></span>
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-[#444c42] hover:text-[#D0A24F] text-sm font-medium py-2 cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('options')}
              className="block w-full text-left text-[#444c42] hover:text-[#D0A24F] text-sm font-medium py-2 cursor-pointer"
            >
              Implant Options
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left text-[#444c42] hover:text-[#D0A24F] text-sm font-medium py-2 cursor-pointer"
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-[#444c42] hover:text-[#D0A24F] text-sm font-medium py-2 cursor-pointer"
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('booking')}
              className="block w-full bg-[#D0A24F] text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-[#F5d383] transition-colors cursor-pointer"
            >
              Book Appointment
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
